import Model from "./Model";

export default class Documentation extends Model {

	constructor(props) {

		super({});

		this.setDefaultValues({
			id: null,
			group: null,
			status: null,
			content: [],
		}, props);
	}

	getContent(lang) {
		return this.content.find(content => content.language === lang);
	}
}
